import { reducer, initialStateBase } from 'Reducers/newCollection';

export const urls = {
    config: '/api/inspection/config',
    checkpoint: '/api/inspection/checkpoint',
    submit: '/api/inspection/submit',
    draft: 'api/inspection/draft',
    postAd: '/api/inspection/ad'
};

const initialState = Object.assign({}, initialStateBase, {
    metadataKey: 'selfInspection'
});

const transformGetData = (url, response) => {
    const urlWithoutParams = url.split('?')[0];
    let transformedData = null;

    switch (urlWithoutParams) {
        case urls.config:
            transformedData = {
                data: response.config
            };
            break;
        default:
            transformedData = {
                data: response
            };
    }

    return transformedData;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_SELF_INSPECTION':
            action.data = transformGetData(action.url, action.data);
            return reducer(state, action, 'SELF_INSPECTION');
        default:
            return reducer(state, action, 'SELF_INSPECTION');
    }
};
